import { authHeader, BASE_URL, handleResponse, RequestQueue } from '@helpers/api';
import { ProductEvent } from '@constants/product-events';
import { captureOnCreate, captureOnSuccess } from '@helpers/product-events';

const contactQueue = new RequestQueue();

function get(params, page, pageSize) {
    return contactQueue.execute(signal => {
        const requestOptions = {
            method: 'POST',
            headers: authHeader(),
            body: JSON.stringify(params),
            signal,
        };

        return fetch(`${BASE_URL}api/contacts?page=${page}&pageSize=${pageSize}`, requestOptions).then(handleResponse);
    });
}

function getContact(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/contacts/${id}`, requestOptions).then(handleResponse);
}

function getContactLocations() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/contacts/locations`, requestOptions).then(handleResponse);
}

function deleteContact(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/contacts/${id}`, requestOptions).then(handleResponse);
}

function deleteBulkContacts(params) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
        body: JSON.stringify({ filter: params }),
    };

    return fetch(`${BASE_URL}api/contacts/bulk-delete`, requestOptions).then(handleResponse);
}

function createOrUpdateContact(data) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/contacts`, requestOptions)
        .then(handleResponse)
        .then(captureOnCreate(data, ProductEvent.ContactCreated));
}

function getBulkEditData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/contacts/bulk-edit-contacts-state`, requestOptions).then(handleResponse);
}

function updateBulkContacts(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/contacts/bulk-edit`, requestOptions).then(handleResponse);
}

function importContactsBulk(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/contacts/import`, requestOptions)
        .then(handleResponse)
        .then(captureOnSuccess(ProductEvent.ContactsImported, () => ({ count: data.contacts?.length })));
}

function getDuplicates(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/contacts/pre-import`, requestOptions).then(handleResponse);
}

function mergeContacts(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/contacts/merge`, requestOptions).then(handleResponse);
}

function exportCSVBulk(query) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(query),
    };
    return fetch(`${BASE_URL}api/contacts/export`, requestOptions)
        .then(handleResponse)
        .then(captureOnSuccess(ProductEvent.DataExported, { resource: 'contacts' }));
}

export const contactsService = {
    get,
    getContact,
    getContactLocations,
    deleteContact,
    deleteBulkContacts,
    createOrUpdateContact,
    updateBulkContacts,
    getBulkEditData,
    importContactsBulk,
    getDuplicates,
    mergeContacts,
    exportCSVBulk,
};
